import React, {Fragment, useState} from 'react';
import {Link, useSearchParams} from "react-router-dom";
import ListEdit from "../UI/ListEdit";
import {useCoupons} from "../../hooks/useCoupons";
import {useCouponUsages} from "../../hooks/useCouponUsages";
import {convertToDisplayDateTime, getOrderStatusBadge, getPaymentStatusBadge} from "../../utility/utility";

// The coupon list endpoint caps the page size at 200, which is enough to offer every coupon in the filter.
const COUPON_FILTER_OPTION_LIMIT = 200;

// The coupon filter is a search param, so the usages icon on the coupon list can link straight to one coupon's usages.
const CouponUsageList = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const filterCouponId = searchParams.get('couponId');
    const {coupons} = useCoupons(1, COUPON_FILTER_OPTION_LIMIT);
    const {couponUsages, pagination} = useCouponUsages(page, pageSize, filterCouponId);

    const handleCouponFilterChange = (event) => {
        setPage(1);
        setSearchParams((previousSearchParams) => {
            const nextSearchParams = new URLSearchParams(previousSearchParams);

            if (event.target.value === '') {
                nextSearchParams.delete('couponId');
            }
            else {
                nextSearchParams.set('couponId', event.target.value);
            }

            return nextSearchParams;
        });
    };

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const handlePageSizeChange = (pageSize) => {
        setPageSize(pageSize);
        setPage(1);
    };

    const couponUsageList = couponUsages.map((item) => ({
        couponUsageId : item.couponUsageId,
        usedAt        : convertToDisplayDateTime(item.usedAt),
        coupon        : <div className="flex flex-col">
            <span>{item.couponName}</span>
            <span className="text-xs text-gray-500">{item.couponCode}</span>
        </div>,
        customer      : item.customerName,
        orderNumber   : <Link to={`/orders/${item.orderId}/items`} className="text-blue-500 hover:underline">{item.orderNumber}</Link>,
        discount      : item.discountBruttoPrice + ' ' + item.currency,
        orderStatus   : getOrderStatusBadge(item.orderStatus),
        paymentStatus : getPaymentStatusBadge(item.paymentStatus),
    }));

    const listHeaders = [
        'Used at',
        'Coupon',
        'Customer',
        'Order #',
        'Discount',
        'Order status',
        'Payment status',
    ];

    const columns = {
        functionParams : ['couponUsageId'],
        dataKeys       : [
            'usedAt',
            'coupon',
            'customer',
            'orderNumber',
            'discount',
            'orderStatus',
            'paymentStatus',
        ],
    }

    return (
        <Fragment>
            <div className="flex flex-wrap gap-3 my-4">
                <select value={filterCouponId ?? ''} onChange={handleCouponFilterChange} className="border p-2">
                    <option value="">All coupons</option>
                    {coupons.map((coupon) => (
                        <option key={coupon.couponId} value={coupon.couponId}>
                            {coupon.name} ({coupon.code})
                        </option>
                    ))}
                </select>
            </div>
            <ListEdit
                headers={listHeaders}
                items={couponUsageList}
                columns={columns}
                pagination={pagination}
                handlePageChange={handlePageChange}
                handlePageSizeChange={handlePageSizeChange}
            />
        </Fragment>
    );
}

export default CouponUsageList;
